import "./styles.scss";

import React from "react";
import clsx from "clsx";

const OpinionCard = ({ url, logo, rating, location, variant }) => {
  return (
    <a
      className={clsx(
        "opinion-card",
        variant && `opinion-card--${variant}`,
        url && `opinion-card--link`
      )}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      <div className="opinion-card__logo">
        <img src={logo} alt="" />
        {url && (
          <div className="opinion-card__logo-arrow">
            <img
              src={require("assets/icons/arrow-right--new.svg").default}
              alt=""
            />
          </div>
        )}
      </div>
      <div className="opinion-card__body">
        {rating?.average && (
          <div className="opinion-card__details opinion-card__details--large">
            <p>
              Średnia ocen{" "}
              <span>{rating.average.toString().replace(".", ",")}/5</span>
            </p>
          </div>
        )}
        <div className="opinion-card__divider" />
        {rating?.amount && (
          <div className="opinion-card__details">
            <p>
              Liczba ocen <span>{rating.amount}</span>
            </p>
          </div>
        )}
        {location && (
          <div className="opinion-card__details">
            <p>
              Lokalizacja <span>{location}</span>
            </p>
          </div>
        )}
      </div>
    </a>
  );
};

export default OpinionCard;
